import { render } from "./EditYoutubeEventModal.vue?vue&type=template&id=64756344"
import script from "./EditYoutubeEventModal.vue?vue&type=script&lang=js"
export * from "./EditYoutubeEventModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__